import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import noiseIcon from '../assets/noise-icon.png';
import { trackPageView } from '../utils/analytics';

const RetroNoisePrivacy = () => {
  useEffect(() => {
    trackPageView('Retro Noise Privacy Policy');
  }, []);

  return (
    <div className="privacy-container">
      <header className="privacy-header">
        <div className="app-info">
          <div className="app-icon">
            <img src={noiseIcon} alt="Retro Noise" />
          </div>
          <div className="app-details">
            <h1>Retro Noise</h1>
            <p>Privacy Policy</p>
          </div>
        </div>
        <Link to="/" className="back-link">← Back to Home</Link>
      </header>

      <main className="privacy-content">
        <div className="privacy-section">
          <h2>Information We Collect</h2>
          <p>Retro Noise respects your privacy. We do not collect any personal information, usage data, or analytics. The app functions entirely offline and does not require any network permissions.</p>
        </div>

        <div className="privacy-section">
          <h2>Audio Processing</h2>
          <p>All audio generation and processing happens locally on your device. No audio data is recorded, stored, or transmitted to external servers.</p>
        </div>

        <div className="privacy-section">
          <h2>User Preferences</h2>
          <p>Your app settings and preferences are stored locally on your device only. This includes volume levels, timer settings, and selected sound profiles.</p>
        </div>

        <div className="privacy-section">
          <h2>Third-Party Services</h2>
          <p>Retro Noise does not use any third-party analytics, advertising networks, or data collection services. The app is completely self-contained.</p>
        </div>

        <div className="privacy-section">
          <h2>Permissions</h2>
          <p>The app only requests audio playback permissions necessary for its core functionality. No microphone, location, or other sensitive permissions are required.</p>
        </div>

        <div className="privacy-section">
          <h2>Contact Us</h2>
          <p>If you have any questions about this Privacy Policy, please contact us at:</p>
          <p><strong>Email:</strong> feedback@peacetech.app</p>
        </div>

        <div className="privacy-section">
          <h2>Updates to This Policy</h2>
          <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date.</p>
          <p><strong>Last updated:</strong> January 2025</p>
        </div>
      </main>
    </div>
  );
};

export default RetroNoisePrivacy;